/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {animations as ɵb} from './components/tag-input/animations';
export {TagInputAccessor as ɵa} from './core/accessor';
export {HighlightPipe as ɵd} from './core/pipes/highlight.pipe';
export {DragProvider as ɵc} from './core/providers/drag-provider';